<template>
  <DefaultLayout>
    <template v-if="privacyLinkHref" #footer-links>
      |
      <a
        v-if="privacyLinkIsExternal"
        :href="privacyLinkHref"
        target="_blank"
        rel="noopener noreferrer"
        class="text-caption text-decoration-none"
      >Confidentialité</a>
      <RouterLink
        v-else
        :to="privacyLinkHref"
        class="text-caption text-decoration-none"
      >Confidentialité</RouterLink>
    </template>
  </DefaultLayout>
  <ConsentModal />
</template>

<script setup lang="ts">
import { DefaultLayout, ConsentModal, usePrivacyConfig } from '@fondationcss/ui';
import { RouterLink } from 'vue-router';

// Le lien « Confidentialité » du pied de page pointe vers la politique interne
// (/confidentialite) ou vers l'URL externe de l'établissement selon la config
// publique Loi 25. La modale de consentement s'auto-affiche lorsqu'un document
// légal en attente est détecté (inerte tant que Core.Privacy n'est pas configuré).
const { privacyLinkHref, privacyLinkIsExternal } = usePrivacyConfig();
</script>
